export var formFieldTheme = {
  baseStyle: _ref => {
    var {
      error,
      helperText,
      isViewMode
    } = _ref;
    return {
      container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 'xxs',
        width: '100%',
        justifyContent: 'end'
      },
      label: {
        '&[data-hidden="true"]': {
          opacity: 0,
          position: 'absolute'
        }
      },
      fieldGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        height: 'auto'
      },
      field: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%'
      },
      helperText: {
        textStyle: 'body4',
        gap: 'm',
        width: '100%',
        display: 'flex',
        justifyContent: !!error || helperText && !isViewMode ? 'space-between' : 'flex-end',
        color: 'neutral.darker',
        height: '16px',
        _invalid: {
          color: 'critical.main'
        },
        _readOnly: {
          color: 'neutral.darker'
        },
        _disabled: {
          color: 'neutral.light'
        }
      }
    };
  },
  sizes: {
    small: {
      fieldGroup: {
        gap: 'xxxs'
      },
      field: {
        minHeight: '40px'
      }
    },
    large: {
      fieldGroup: {
        gap: 'xxs'
      },
      field: {
        minHeight: '48px'
      }
    }
  }
};
//# sourceMappingURL=FormField.theme.js.map